<template>
  <div>
    <Navigation/>
    <!-- 黑白上色 -->
    <div class="bg_box">
      <div class="noneBox"></div>
      <div class="box">
        <p class="back" @click="$router.push('/wordNav')">返回</p>
        <div class="ct_box flex">
          <div class="form_upload_box">
            <ai_title ai_title="“智能生成”_图片风格转换"/>
            <p class="from_title_new">图片风格转换</p>
            <div class="transparent_box">
              <ai_upload_img @getImg="getImg"/>
              <div class="flex" style="margin-bottom: 20px;">
                <!-- <p class="upLoad_text">链接地址</p>
                <div class="upload_box">
                  <el-input v-model="contentData.origin_url" placeholder="请输入图片链接地址"></el-input>

                </div> -->
              </div>
              <ai_select selectTitle="风格类型" :select_list="type_list" @getSelectVal="getStyle"/>
              <ai_button_file_data ref="ai_button_file_data" @file_data="file_data"/>
              <ai_img :type="2" contentName='转换后图片' :contentData="contentData"/>
            </div>

            <aiNum title="计费规则：本次生成图片风格转换预计消费0.45元" :visible="aiNumShow" @close="aiNumShow = false"
                   @postData="postData"/>
            <aiPoup :visible="aiPoupShow" @close="aiPoupShow = false"/>
          </div>
          <wordNav/>

        </div>

      </div>


    </div>
    <footerBot/>
  </div>
</template>

<script>
import ai_upload_img from '@/components/ai_upload_img'
import ai_select from '@/components/ai_select'
import ai_img from '@/components/ai_img'
import wordNav from '@/components/wordNav'
import ai_title from '@/components/ai_title'
import ai_button_file_data from '@/components/ai_button_file_data'

export default {
  mounted() {
    this.getUserInfo()
  },
  components: {
    wordNav,
    ai_upload_img,
    ai_img,
    ai_select,
    ai_title,
    ai_button_file_data
  },
  data() {
    return {
      fileList: [],
      type_list: [
        {
          id: 'cartoon',
          name: '卡通画风格'
        },
        {
          id: 'pencil',
          name: '铅笔风格'
        },
        {
          id: 'color_pencil',
          name: '彩色铅笔画风格'
        },
        {
          id: 'warm',
          name: '彩色糖块油画风格'
        },
        {
          id: 'wave',
          name: '神奈川冲浪里油画风格'
        },
        {
          id: 'lavender',
          name: '薰衣草油画风格'
        },
        {
          id: 'mononoke',
          name: '奇异油画风格'
        },
        {
          id: 'scream',
          name: '呐喊油画风格'
        },
        {
          id: 'gothic',
          name: '哥特油画风格'
        }
      ],
      contentData: {
        origin_url: '',
        // cover_url: '',
        output_content: '',
        type: '',
        type_text: '',
      }, //内容
      aiNumShow: false,
      aiPoupShow: false,
    }
  },
  methods: {
    getStyle(val) {
      console.log(val);
      this.contentData.type = val
      console.log(this.contentData.type_text);
    },
    getImg(url) {
      this.contentData.origin_url = url
      console.log('contentData', this.contentData);
    },
    // 获取用户信息
    getUserInfo() {
      let $user_info = JSON.parse(localStorage.getItem('user_info'))
      if ($user_info) {
        this.curlGet('/api/user/info').then((res) => {
          if (res.data.code) {
            this.$user_info = res.data.data
            this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
          }
        })
      }
    },
    file_data() {
      if (this.$user_info.money <= 0) {
        this.aiPoupShow = true
      } else {
        this.aiNumShow = true
      }
    },
    postData() {
      this.aiNumShow = false
      this.$refs.ai_button_file_data.loading_show()
      let data = {}
      data.mobile = this.$user_info.mobile
      for (const key in this.contentData) {
        if (key != 'output_content' && key != 'type_text') {
          data[key] = this.contentData[key]

        }
      }
      this.curlPost('file/drawing_style', data).then(res => {
        this.$refs.ai_button_file_data.loading_show()
        if (res.data.code) {
          this.contentData.output_content = res.data.data.output_content

          // 扣费
          this.curlPost('/api/users/money_log/spend', {
            ai_id: res.data.data.id,
            amount: res.data.data.money,
          }).then(res => {
            if (res.data.code) {
              this.getUserInfo()
            }
          })
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },


  },
}
</script>

<style lang=scss scoped>
@use '@/scss/ai'
</style>